import { useMemo } from 'react'

import {
  bootcampOverview,
  bootcampOverviewGroq,
  bootcampOverviewModule,
  BootcampOverviewUserData,
} from '~/types/bootcamp'

import { getBootcampProgress } from '~/bootcamp/utils/getBootcampProgress.utils'

export default function useProcessGymOverviewData(
  gymOverviewData: bootcampOverviewGroq,
  processedData?: BootcampOverviewUserData[],
): bootcampOverview {
  const result = useMemo(() => {
    return {
      name: gymOverviewData?.name,
      intro: gymOverviewData?.intro,
      // eslint-disable-next-line fp/no-mutating-methods
      modules: gymOverviewData?.modules
        ?.map<bootcampOverviewModule>((res) => {
          const { progress, hasDefeatedBoss, totalChests, earnedChests } = getBootcampProgress(res, processedData)

          return {
            badgeImage: res.badgeImage,
            badgeOutlineImage: res.badgeOutlineImage,
            name: res.name,
            taskReferences: res.taskReferences,
            moduleNumber: res.moduleNumber,
            levels: res.levels,
            bossDefeated: hasDefeatedBoss,
            progress,
            chests: {
              total: totalChests,
              collected: earnedChests,
            },
            prerequisites: res.prerequisites,
            hasWhyLevel: res.hasWhyLevel,
            firstPageData: res.firstPageData,
            tagStatus: res.tagStatus,
            isUpcoming: !!res.isUpcoming,
          }
        })
        .sort((a, b) => +a.moduleNumber - +b.moduleNumber),
    }
  }, [gymOverviewData, processedData])

  return result
}
